import loadingImg from "../assets/robot-loader.gif";
export const tmpl = `<div class="sh-widget-overview-container">
    <div class="sh-widget-loader">
        <img src="${loadingImg}" alt="Loading...">
    </div>
    <div class="sh-widget-overview-new">
        <h5>New Detections <button data-sh-widget-tooltip="Number of new detections relating to IPv4 and IPv6 addresses over the past 24 hours." class="sh-widget-tooltip-button white">i</button></h5>
        <div data-element="listings-new" class="sh-widget-listings-count"></div>
        <div>
            <span data-element="listings-new-change" class="sh-pill">--</span>
        </div>
        <p class="sh-widget-listings-new-date">Last 24 hours</p>
        <p><span class="sh-widget-listings-new-date-content" data-element="listings-new-date"></span></p>
    </div>
    <div class="sh-widget-overview-main">
        <h3>Total detections <button data-sh-widget-tooltip="Total number of individual IPv4 & IPv6 addresses included in the dataset." class="sh-widget-tooltip-button blue">i</button></h3>
        <p>Including new detections</p>
        <div data-element="listings-all" class="sh-widget-listings-all"></div>
        <div>
            <span data-element="listings-all-change" class="sh-pill"></span>
        </div>
        <div data-element="listings-all-date" class="sh-widget-listings-all-date"></div>
        <hr>
        <div class="sh-widget-flex">
            <div class="sh-flex-item">
                <h5>IPv4 detections <button data-sh-widget-tooltip="Total number of IPv4 addresses included in the dataset." class="sh-widget-tooltip-button blue">i</button></h5>
                <div data-element="listings-ipv4" class="sh-widget-listings-count"></div>
                <div><span data-element="listings-ipv4-change" class="sh-pill"></span></div>
            </div>
            <div class="sh-flex-item">
                <h5>IPv6 detections <button data-sh-widget-tooltip="Total number of IPv6 addresses included in the dataset." class="sh-widget-tooltip-button blue">i</button></h5>
                <div data-element="listings-ipv6" class="sh-widget-listings-count"></div>
                <div><span data-element="listings-ipv6-change" class="sh-pill"></span></div>
            </div>    
        </div>
        <hr>
        <h5>Total file size <button data-sh-widget-tooltip="Total size of the dataset when downloaded via the Spamhaus Intelligence API (SIA)." class="sh-widget-tooltip-button blue">i</button></h5>
        <div>
            <span data-element="listings-filesize" class="sh-widget-listings-filesize"></span>
        </div>
    </div>
</div>`;
